<template>
  <div class="notification-form flex-grow-1 d-flex flex-column">
    <CustomElementForm :notification="notification" @submit="onSubmit($event)" />
  </div>
</template>

<script>
  import CustomElementForm from './CustomElementForm';
  import CustomElementService from '../services/customElement.service';
  export default {
    name: 'NotificationAdd',
    components: {
      CustomElementForm
    },
    data() {
      return {
        notification: {
          contact_group_id: null,
          url_id: null,
          notification_type: null
        }
      };
    },
    methods: {
      async onSubmit(event) {
        console.log("emit passed :)")
        console.log(event)
        try {
          await CustomElementService.createCustomElement(event.element_name, event.description, event.xpath);
          this.$router.push('/custom-element/list');
          this.$showSuccessMessage('Added Custom Element!');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
